import { takeEvery, put, take } from "redux-saga/effects";//header
//header
import { GET_ACTIVITY_DATA,GET_ACTIVITY_SELECT_DATA } from "../../common/VoteActivity/store/actionTypes";
import { setActivityData ,setActivitySelectData } from "../../common/VoteActivity/store/actionCreators";
import $axios from "../../request";
import { Toast} from 'antd-mobile';
import {setHeaderData} from "../../common/Header/store/actionCreators";

function* mySaga() {
    yield takeEvery(GET_ACTIVITY_DATA, _getActivityData);
    yield takeEvery(GET_ACTIVITY_SELECT_DATA, _getActivitySelectData)
}


function* _getActivitySelectData(e) {
    console.log("_getActivitySelectData",e)
    if (e.data) {
        yield put(setActivitySelectData(e.data))
    }

}

function* _getActivityData() {
    let url = '/vote/activity/list';
    let data = {
        search:[{
            "key": 'state',
            "type": 'bool',
            "value": true
        }]
    }

    let res =  $axios.postRequest(url, data)
    let object = null
    yield res.then(response => {
        console.log(url, response);
        object = response;

    })
    yield put(setActivityData(object?.data))
}



export default mySaga
